import { render } from "./footerBanner.vue?vue&type=template&id=2396001a&scoped=true"
import script from "./footerBanner.vue?vue&type=script&lang=js"
export * from "./footerBanner.vue?vue&type=script&lang=js"

import "./footerBanner.vue?vue&type=style&index=0&id=2396001a&lang=less&scoped=true"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2396001a"]])

export default __exports__